import { FC } from 'react'
import Typography from '../atoms/Typography'
import { formatArea } from 'src/enviroment/lib/utils'
import { cn } from 'src/enviroment/lib/utils'

interface AreaSizeMessageProps {
  hectares: number
  isValidating?: boolean
  limitExceeded?: boolean
}

const AreaSizeMessage: FC<AreaSizeMessageProps> = ({ hectares, isValidating = false, limitExceeded = false }) => (
  <div
    className={cn(
      'flex items-start rounded-lg border bg-gray-800 px-4 py-3',
      limitExceeded ? 'border-red-ramo' : 'border-orange-500',
    )}
  >
    <div className="flex flex-col items-start whitespace-nowrap text-gray-50">
      <Typography variant="xs">Area Size</Typography>
      <div className="relative">
        <Typography variant="sm-bold" className={cn(isValidating && 'invisible')}>
          {formatArea(hectares)}
        </Typography>
        {isValidating && <div className="absolute inset-0 my-0.5 animate-pulse rounded bg-gray-700" />}
      </div>
    </div>
  </div>
)

export default AreaSizeMessage
